/**
 * LandingNav — top navigation on the public landing page.
 *
 * Logo + brand name on the left; Features / Pricing / Contact text
 * links + Log In + orange Try Free CTA on the right. Sticky-ready
 * (wrapped in a `<nav>` with the dark hero background colour).
 *
 * "Try Free" actually opens the inquiry form pre-set to the
 * waitlist inquiry type — there is no self-serve trial yet, so
 * "Try Free" smoothly degrades into the sales contact path.
 */

import { type ReactNode } from 'react'
import { LogoDoor }       from '@/components/brand/LogoDoor'

export interface LandingNavProps {
  onScrollToSection: (id: 'features' | 'pricing' | 'inquiry-form') => void
  onSignIn:          () => void
  onTryFree:         () => void
}

export function LandingNav({
  onScrollToSection,
  onSignIn,
  onTryFree,
}: LandingNavProps): ReactNode {
  return (
    <nav className="landing-nav" aria-label="Primary">
      <div className="landing-nav__inner">
        <div className="landing-nav__brand">
          <LogoDoor size={36} />
          <span className="landing-nav__name">
            ReadyRoomOps<sup>™</sup>
          </span>
        </div>

        <div className="landing-nav__links">
          <button type="button" className="landing-nav__link" onClick={() => onScrollToSection('features')}>
            Features
          </button>
          <button type="button" className="landing-nav__link" onClick={() => onScrollToSection('pricing')}>
            Pricing
          </button>
          <button type="button" className="landing-nav__link" onClick={() => onScrollToSection('inquiry-form')}>
            Contact
          </button>
        </div>

        <div className="landing-nav__cta-group">
          <button type="button" className="landing-nav__login" onClick={onSignIn}>
            Log In
          </button>
          <button type="button" className="landing-cta landing-cta--primary" onClick={onTryFree}>
            Try Free
          </button>
        </div>
      </div>
    </nav>
  )
}
